// extracted by mini-css-extract-plugin
module.exports = {"above-small":"851px","container":"AutoCompleteItem-module__container___1DLJb","name":"AutoCompleteItem-module__name___3C4LA","badge":"AutoCompleteItem-module__badge___3Fe86"};